import { render, staticRenderFns } from "./MyYear.vue?vue&type=template&id=6643d31a"
import script from "./MyYear.vue?vue&type=script&lang=js"
export * from "./MyYear.vue?vue&type=script&lang=js"
import style0 from "./MyYear.vue?vue&type=style&index=0&id=6643d31a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports